// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"searchHeader_headerContainer__baX8A","isSearcher":"searchHeader_isSearcher__2rF06"};